function setupPopupTriggers() {
  document.querySelectorAll('[open-popup]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      console.log('[ Custom Button Event Fired ]')
      const targetId = trigger.getAttribute('open-popup');
      const popup = document.getElementById(targetId);
      if (popup && popup.open){} popup.open();
    });
  });

  document.querySelectorAll('[close-popup]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('close-popup');
      const popup = document.getElementById(targetId);
      if (popup && popup.close) popup.close();
    });
  });
};

function iniToolTips(){
  console.log("%c ToolTip Initialized 🚀", "color:rgb(107, 205, 244); font-size: 11px;");
  const tooltipAttrPrefixes = ["ctool-tip-top", "ctool-tip-right", "ctool-tip-bottom", "ctool-tip-left"];
  tooltipAttrPrefixes.forEach(attr => {
    document.querySelectorAll(`[${attr}]`).forEach(el => {
      const text = el.getAttribute(attr);
      const position = attr.split("ctool-tip-")[1];
  
      // Create tooltip element
      const tooltip = document.createElement("div");
      tooltip.className = `dynamic-tooltip ${position}`;
      tooltip.textContent = text;
  
      // Basic styles
      Object.assign(tooltip.style, {
        position: "absolute",
        background: "#333",
        color: "#fff",
        padding: "6px 10px",
        fontSize: "12px",
        borderRadius: "4px",
        whiteSpace: "nowrap",
        opacity: "0",
        pointerEvents: "none",
        transition: "opacity 0.2s ease",
        zIndex: 1000,
      });
  
      el.style.position = "relative";
      el.appendChild(tooltip);
  
      el.addEventListener("mouseenter", () => {
        tooltip.style.opacity = "1";
      });
  
      el.addEventListener("mouseleave", () => {
        tooltip.style.opacity = "0";
      });
  
      // Tooltip positioning logic
      el.addEventListener("mousemove", () => {
        switch (position) {
          case "top":
            tooltip.style.bottom = `${el.offsetHeight + 6}px`;
            tooltip.style.left = "50%";
            tooltip.style.transform = "translateX(-50%)";
            break;
          case "right":
            tooltip.style.top = "50%";
            tooltip.style.left = `${el.offsetWidth + 6}px`;
            tooltip.style.transform = "translateY(-50%)";
            break;
          case "bottom":
            tooltip.style.top = `${el.offsetHeight + 6}px`;
            tooltip.style.left = "50%";
            tooltip.style.transform = "translateX(-50%)";
            break;
          case "left":
            tooltip.style.top = "50%";
            tooltip.style.right = `${el.offsetWidth + 6}px`;
            tooltip.style.transform = "translateY(-50%)";
            break;
        }
      });
    });
  });
}


export {
  setupPopupTriggers,
  iniToolTips
}